export default class GameConfig {
    static SPEED = 142;
    static JUMP_THRUST = 590;
    static ZOOM_FACTOR = 2;
    static SCREEN_WIDTH = 35 * 16 * this.ZOOM_FACTOR;
    static SCREEN_HEIGHT = 20 * 16 * this.ZOOM_FACTOR;
    static JUMP_FRAME_INDEX = 4;
    static CLIMB_SPEED = 150;
    static COYOTE_TIME = 54;

    static updateValue(property, value) {
        if (this.hasOwnProperty(property)) {
            this[property] = value;
        }
    }
}